/**
 * This is an HOC that mimics a global state subscription system.
 * It tries to serve the same purpose as Redux--updating a component's
 * props when global state changes--in a simple and naive way.
 *
 * Tell it which properties of window.gs to "subscribe" to via the
 * gsPropertyNames array. Then your component's props will update when
 * one of those variables changes.
 */

import React from 'react';

const InjectPropsFromGS = (/** @type {Array.<string>} */ gsPropertyNames, interval=5000, once=false) => (Component) => class InjectPropsFromGS extends React.Component {

  static WrappedComponent = Component;

  constructor(props) {
    super(props);
    this.state = this.checkGlobalState(true);
    this._timer = setInterval(this.checkGlobalState, interval);
  }

  componentWillUnmount() {
    clearInterval(this._timer);
  }

  checkGlobalState = (firstRun=false) => {
    let nextState = { ...this.state };
    let didChange = false;

    if (!Array.isArray(gsPropertyNames)) {
      gsPropertyNames = [gsPropertyNames];
    }

    gsPropertyNames.forEach(key => {
      if (nextState[key] !== window.gs[key]) {
        nextState[key] = window.gs[key];
        didChange = true;
      }
    });

    if (firstRun) {
      return nextState;
    }

    if (didChange) {
      this.setState(nextState);

      if (once) {
        clearInterval(this._timer);
      }
    }
  }

  render() {
    return (
      <Component {...this.props} {...this.state} />
    );
  }

};

export default InjectPropsFromGS;
